const ip_blacklist = {
	deblock_dialog: {
		description: "Are you sure you want to unblock IP address <strong>{{ip_address}}</strong>?",
		title: "Unblock IP Address",
	},
	on_success: "IP address unblocked successfully",
	table: {
		created_at: "Blocked On",
		failures: "Failed Login Attempts",
		id: "ID",
		ip_address: "IP Address",
		no_items: "No items found",
		username: "Username",
	},
	title: "IP Blacklist",
};

export default ip_blacklist;
